import { render, staticRenderFns } from "./selectorLabor.vue?vue&type=template&id=b7a0c30e&scoped=true&"
import script from "./selectorLabor.vue?vue&type=script&lang=js&"
export * from "./selectorLabor.vue?vue&type=script&lang=js&"
import style0 from "./selectorLabor.vue?vue&type=style&index=0&id=b7a0c30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a0c30e",
  null
  
)

export default component.exports